var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    attrs: {
      "id": "asideModule"
    }
  }, [_c('el-tabs', {
    attrs: {
      "tab-position": _vm.tabPosition
    },
    on: {
      "tab-click": _vm.clickTab
    },
    model: {
      value: _vm.tabVal,
      callback: function ($$v) {
        _vm.tabVal = $$v;
      },
      expression: "tabVal"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "name": "raisHand"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "iconfont icon-un-raisehand",
    class: {
      unread: _vm.raiseHandList.length
    }
  })]), _c('raiseHandList', {
    attrs: {
      "raiseHandList": _vm.raiseHandList,
      "tagNameInfo": _vm.tagNameInfo,
      "rtilCode": _vm.rtilCode,
      "userInfo": _vm.userInfo
    },
    on: {
      "changeHandList": _vm.changeHandList,
      "callback": _vm.callback
    }
  })], 1), _c('el-tab-pane', {
    attrs: {
      "name": "chat"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "el-icon-chat-line-square",
    class: {
      unread: _vm.showUnread
    }
  })]), _vm.loadChatBox ? _c('div', {
    staticClass: "chatBox"
  }, [_c('ChatMessage', {
    attrs: {
      "userInfo": _vm.userInfo,
      "allPartyMembers": _vm.allPartyMembers,
      "chatPartyCode": _vm.userInfo.realPartyCode,
      "showComponent": _vm.showComponent,
      "organizationInfo": _vm.organizationInfo,
      "tagNameInfo": _vm.tagNameInfo,
      "nickNameInfo": _vm.nickNameInfo
    },
    on: {
      "callback": _vm.chatCallback
    }
  })], 1) : _vm._e()])], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };